/**
 * TropicalFronds — decorative palm-frond corner accents for the pre-auth
 * pages (login / get-started / signup). Purely visual: aria-hidden and
 * pointer-events none, so it never affects a11y or interaction.
 *
 * Uses the fixed brand greens (pre-auth pages render before the user's theme
 * loads, §85) at low opacity so the fronds read as a watermark on both the
 * dark brand background and lighter contexts.
 *
 * The host container must be `position: relative` (and ideally
 * `overflow: hidden`) — the fronds anchor to its corners.
 */

const BLADE = "M0 0 C42 -12 116 -20 196 -9 C118 3 44 8 0 0 Z";
const ANGLES = [-84, -68, -53, -39, -26, -15, -6];
const SCALES = [0.72, 0.85, 0.95, 1.02, 1.0, 0.9, 0.78];

function Fan({ fill }: { fill: string }) {
  return (
    <>
      {ANGLES.map((a, i) => (
        <path key={a} d={BLADE} fill={fill} transform={`rotate(${a}) scale(${SCALES[i]})`} />
      ))}
    </>
  );
}

export function TropicalFronds({ opacity = 0.13 }: { opacity?: number }) {
  return (
    <div
      aria-hidden="true"
      style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none" }}
    >
      {/* bottom-left fan */}
      <svg
        width="380"
        height="360"
        viewBox="0 0 380 360"
        style={{ position: "absolute", left: -36, bottom: -36, opacity }}
      >
        <g transform="translate(16 344)">
          <Fan fill="#2D6A2F" />
        </g>
        <g transform="translate(16 344) rotate(-8) scale(0.8)" opacity="0.6">
          <Fan fill="#5FA85F" />
        </g>
      </svg>
      {/* top-right fan (the same fan rotated 180° fans down-left from the corner) */}
      <svg
        width="300"
        height="280"
        viewBox="0 0 380 360"
        style={{
          position: "absolute",
          right: -48,
          top: -44,
          opacity: opacity * 0.85,
          transform: "rotate(180deg)",
        }}
      >
        <g transform="translate(16 344)">
          <Fan fill="#2D6A2F" />
        </g>
        <g transform="translate(16 344) rotate(-10) scale(0.75)" opacity="0.6">
          <Fan fill="#5FA85F" />
        </g>
      </svg>
    </div>
  );
}

export default TropicalFronds;
